<template>
  <v-app>
    <TheTopBar />
    <TheLoginManager/>
    <LocaleSelector/>
    <v-main id="content">
      <TheNotifier />
      <router-view />
    </v-main>

    <v-footer class="pa-4">
      <v-spacer></v-spacer>
      <span class="mr-3">v1.0.0 | Made by <a href="https://www.synolia.com/dxp/portail-applicatif/" target="_blank" style="color: #BB2080">Synolia</a></span>
      <img :src="require('@/assets/menu_icon_dark.png')" alt="logo" style="max-height: 25px;">
    </v-footer>
  </v-app>
  
  
</template>

<script>
  import TheTopBar from '@/components/Navigation/TheTopBar'
  import TheNotifier from '@/components/Notification/TheNotifier'
  import TheLoginManager from '@/components/Login/TheLoginManager'
  import LocaleSelector from '@/components/Utils/LocaleSelector'
  import { mapState } from 'vuex'
  export default {
    components: { 
      TheTopBar, 
      TheNotifier,
      TheLoginManager,
      LocaleSelector
    },
    computed: {
      ...mapState('auth', [
        'isLogged'
      ]),
    }
  }
</script>